<template>
  <div class="mt-4">

    <!-- Modal -->
    <ModalForm />

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center">
      <h3><strong>Países configurados</strong></h3>
      <b-button v-if="validarPermisoComponente('empresa-editar-variables-configurables')" type="button" variant="primary" @click="() => onHandleShowModalForm('CREATE')">
          <i class="fa fa-plus" />
          <span class="ml-1">Agregar</span>
      </b-button>
    </div>

    <!-- Tabla historial -->
    <table class="table my-2">
      <thead>
        <tr>
          <th width="5%">#</th>
          <th width="28%">País</th>
          <th width="15%">Idioma nativo</th>
          <th width="12%">Regulación</th>
          <th width="10%">Período</th>
          <th width="10%">Indicativo</th>
          <th width="15%">Teléfono</th>
          <th width="8%">Estado</th>
          <th v-if="validarPermisoComponente('empresa-editar-variables-configurables')" width="10%" class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody v-if="configurableVariables.data && !!configurableVariables.data.length">
        <tr
          v-for="(item, key) in configurableVariables.data"
          :key="key"
        >
          <td>{{ key + 1 }}</td>
          <td>
            <div class="d-flex align-items-center">
              <img 
                :src="`https://flagsapi.com/${item.country.code}/flat/24.png`" 
                :alt="`Bandera de ${item.country.name}`"
                class="me-2"
                style="width: 24px; height: 18px; border-radius: 2px;"
                @error="onFlagError($event)"
              />
              <span>{{ `${item.country.code} - ${item.country.name}` }}</span>
              <i v-if="item.is_main" class="fa fa-check-circle text-success ml-1" style="font-size: 14px;"></i>
            </div>
          </td>
          <td>
            <span v-if="getNativeLanguage(item.country)">
              {{ getNativeLanguage(item.country).name }}
            </span>
            <span v-else class="text-muted">-</span>
          </td>
          <td>
            <div v-if="item.country.country_setting">
              <b-badge 
                :variant="item.country.country_setting.has_regulatory_review ? 'info' : 'secondary'" 
                class="px-2 py-1"
              >
                {{ item.country.country_setting.has_regulatory_review ? 'Sí' : 'No' }}
              </b-badge>
            </div>
            <span v-else class="text-muted">-</span>
          </td>
          <td>
            <span v-if="item.country.country_setting && item.country.country_setting.has_regulatory_review">
              {{ item.country.country_setting.regulatory_review_period }} años
            </span>
            <span v-else class="text-muted">-</span>
          </td>
          <td>
            <strong v-if="item.phone_code">{{ "+" + item.phone_code }}</strong>
            <span v-else class="text-muted">-</span>
          </td>
          <td>
            <span v-if="item.phone">{{ item.phone }}</span>
            <span v-else class="text-muted">-</span>
          </td>
          <td>
            <b-badge class="px-3 py-1" v-if="!!item.is_active" variant="success">Activo</b-badge>
            <b-badge class="px-3 py-1" v-else variant="danger">Inactivo</b-badge>
          </td>
          <td v-if="validarPermisoComponente('empresa-editar-variables-configurables')">
            <!-- Acciones -->
            <div class="d-flex justify-content-end align-items-center">

              <!-- Editar -->
              <el-tooltip effect="dark" placement="top" content="Editar" popper-class="py-1 px-2">
                <i role="button" @click="() => onHandleShowToEdit(item)" class="fa fa-edit fa-lg text-dark ml-1 cursor-pointer" />
              </el-tooltip>

              <!-- Cambiar estado -->
              <el-tooltip effect="dark" placement="top" :content="item.is_active ? 'Inactivar': 'Activar'" popper-class="py-1 px-2">
                  <i role="button" v-if="item.is_active" @click="() => onChangeStatusConfigurableVariable(item)" class="fa fa-close fa-lg text-danger ml-2 cursor-pointer" />
                  <i role="button" v-else @click="() => onChangeStatusConfigurableVariable(item)" class="fa fa-check fa-lg text-info ml-1 cursor-pointer" />
              </el-tooltip>

            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
          <tr>
              <td :colspan="validarPermisoComponente('empresa-editar-variables-configurables') ? 9 : 8" class="p-3 text-center">
                  <span> <i class="fa fa-info-circle mr-2"></i> No hay resultados para mostrar.</span>
              </td>
          </tr>
      </tbody>
    </table>

    <!-- Paginación -->
    <div class="mb-4" v-if="configurableVariables.data && !!configurableVariables.data.length" >
        <el-pagination
            v-model="filter.page"
            layout="total, sizes, prev, pager, next"
            class="float-right"
            :current-page.sync="filter.page"
            :page-size.sync="filter.per_page"
            :page-sizes="[10, 30, 50, 100]"
            :total="configurableVariables.total"
            @size-change="changePageInPagination"
            @current-change="changePageInPagination"
        />
        <br />
    </div>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from 'vuex';
import Swal from 'sweetalert2';
import { validarPermisoComponente } from "@/plugins/acl";

// Componentes
import ToggleCheckComponent from '../../../../shared/toggle-classes'
import ModalForm from './ModalForm'

export default {
  name: 'historyConfigurableVariables',
  data() {
    return {
        validarPermisoComponente: validarPermisoComponente,
    }
  },
  components: { ToggleCheckComponent, ModalForm },
  computed: {
    // Estados del modulo Empresas
    ...mapState('empresa', [
      'selectedEmpresa'
    ]),
    // Estados del modulo Configuración de países
    ...mapState('configurableVariables', [
      'configurableVariables',
      'filter',
      'modalForm'
    ])
  },
  methods: {
    // Metodos del modulo Configuración de países
    ...mapActions('configurableVariables', [
      'loadConfigurableVariables',
      'updateConfigurableVariable'
    ]),
    // Mutaciones del modulo Configuración de países
    ...mapMutations('configurableVariables', [
      'setDefaultConfigurableVariable',
      'setConfigurableVariable',
      'setModalForm',
    ]),
    /**
     * Obtener el idioma nativo de un país
     *
     * @author Fernando Claros
     */
    getNativeLanguage(country) {
      if (!country.country_setting || !country.country_setting.languages) {
        return null;
      }
      
      return country.country_setting.languages.find(lang => lang.is_native === 1);
    },
    /**
     * Manejar error al cargar la bandera
     *
     * @author Fernando Claros
     */
    onFlagError(event) {
      // Imagen de respaldo o ocultar en caso de error
      event.target.style.display = 'none';
    },
    /**
     * Cambiar de pagina en el paginador.
     *
     * @author Fernando Claros
     */
    async changePageInPagination() {
      const payload = {
        companyId: this.selectedEmpresa.id,
        page: this.filter.page,
        status: 'ALL'
      };
      await this.loadConfigurableVariables(payload)
    },
    /**
     * Cambiar el estado de una Variable configurable
     *
     * @author Fernando Claros
     */
    async onChangeStatusConfigurableVariable(configurableVariable) {

      const payload = {
        ...configurableVariable,
        is_active: configurableVariable.is_active ? 0 : 1,
        page: this.filter.page
      }

      const action = payload.is_active == 0 ? 'inactivar' : 'activar'

      Swal.fire({
        icon: "warning",
        title: "Configuración de países",
        text: `¿Está seguro que desea ${action} la variable?`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) await this.updateConfigurableVariable(payload);
      });

    },
    /**
     * Mostrar datos de la Variable configurable para editarla.
     *
     * @author Fernando Claros
     */
    onHandleShowToEdit(item) {
      this.setConfigurableVariable(item);
      this.onHandleShowModalForm('EDIT');
    },
    /**
     * Mostrar modal del formulario para crear/editar.
     *
     * @author Fernando Claros
     */
    onHandleShowModalForm(action = 'CREATE') {
      if(action === 'CREATE') this.setDefaultConfigurableVariable();

      const payload = {
        isOpen: true,
        action
      };
      this.setModalForm(payload);
    }
  }
};
</script>

<style scoped>
.me-2 {
  margin-right: 0.5rem;
}
</style>